import { Record, Union } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { class_type, record_type, string_type, union_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { Lang, Lang_$reflection } from "./Common.js";
import { defaultArg, orElse, defaultArgWith, bind } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { add, empty, tryFind } from "../fable_modules/fable-library-js.4.24.0/Map.js";
import { interpolate, toText } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { compare } from "../fable_modules/fable-library-js.4.24.0/Util.js";

export class PageCode extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Home", "Login", "Product"];
    }
}

export function PageCode_$reflection() {
    return union_type("Shopfoo.Domain.Types.Translations.PageCode", [], PageCode, () => [[], [], []]);
}

export class TagCode extends Union {
    constructor(code) {
        super();
        this.tag = 0;
        this.fields = [code];
    }
    cases() {
        return ["TagCode"];
    }
}

export function TagCode_$reflection() {
    return union_type("Shopfoo.Domain.Types.Translations.TagCode", [], TagCode, () => [[["code", string_type]]]);
}

export class TranslationKey extends Record {
    constructor(Page, Tag) {
        super();
        this.Page = Page;
        this.Tag = Tag;
    }
}

export function TranslationKey_$reflection() {
    return record_type("Shopfoo.Domain.Types.Translations.TranslationKey", [], TranslationKey, () => [["Page", PageCode_$reflection()], ["Tag", TagCode_$reflection()]]);
}

export class Translations extends Record {
    constructor(Lang, Pages) {
        super();
        this.Lang = Lang;
        this.Pages = Pages;
    }
}

export function Translations_$reflection() {
    return record_type("Shopfoo.Domain.Types.Translations.Translations", [], Translations, () => [["Lang", Lang_$reflection()], ["Pages", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [PageCode_$reflection(), class_type("Microsoft.FSharp.Collections.FSharpMap`2", [TagCode_$reflection(), string_type])])]]);
}


export function Translations__GetOrNone_380951C8(x, key) {
    return bind((table_1) => tryFind(key.Tag, table_1), tryFind(key.Page, x.Pages));
}

export function Translations__Get_54CE5CB0(x, key, defaultValue) {
    return defaultArgWith(orElse(Translations__GetOrNone_380951C8(x, key), defaultValue), () => Translations_fallbackText_380951C8(key));
}

export function Translations_fallbackText_380951C8(key) {
    return toText(interpolate("[*** %A%P().%s%P() ***]", [key.Page, key.Tag.fields[0]]));
}

export const TranslationsModule_Empty = new Translations(new Lang(0, []), empty({
    Compare: compare,
}));

export function TranslationsModule_addByCodes(pageCode, tagCode, value, translations) {
    return new Translations(translations.Lang, add(pageCode, add(tagCode, value, defaultArg(tryFind(pageCode, translations.Pages), empty({
        Compare: compare,
    }))), translations.Pages));
}

export function TranslationsModule_add(key, value, translations) {
    return TranslationsModule_addByCodes(key.Page, key.Tag, value, translations);
}

